import { useMemo, useSyncExternalStore } from 'react';
import AssetsTable from './AssetsTable/AssetsTable';
import RecentEvents from './RecentEvents/RecentEvents';
import ClipRecommendation from '@/Pages/HomePageNew/ClipRecommendation/ClipRecommendation';
import HomeHeader from '@/Pages/HomePageNew/HomeHeader';
import featureFlagStore from '@/stores/featureFlagStore';
import { FeatureFlagKeys } from '@/services/featureFlag';
import useFreeTrialHook from '@/hooks/useFreeTrialHook';

export default function Sessions(): JSX.Element {
  const featureFlags = useSyncExternalStore(featureFlagStore.subscribe, featureFlagStore.getSnapshot);
  const isCLHomePageEnabled = featureFlags[FeatureFlagKeys.Use_CL_New_HomePage];
  const { isFreeTrialEnabled, isFreemiumUser } = useFreeTrialHook();

  const showAssetsTable = useMemo(() => isFreeTrialEnabled || isFreemiumUser, [isFreeTrialEnabled, isFreemiumUser]);

  if (!isCLHomePageEnabled) {
    return (
      <div className="flex grow flex-col overflow-hidden bg-slate-50">
        <RecentEvents />
        <AssetsTable />
      </div>
    );
  }

  return (
    <div className="flex grow flex-col overflow-hidden bg-white">
      <div className="m-6 mr-0">
        <HomeHeader />
        <RecentEvents />
        {showAssetsTable ? <AssetsTable showNewContentButton={false} /> : <ClipRecommendation />}
      </div>
    </div>
  );
}
